import AttendanceService from '../services/AttendanceService';

class AttendanceController {
  async getAttendanceData(filters = {}) {
    try {
      const data = await AttendanceService.getAttendanceList(filters);
      return { success: true, data };
    } catch (error) {
      console.error('Get attendance error:', error);
      return { success: false, error: error.message };
    }
  }

  async createAttendance(attendanceData) {
    try {
      const data = await AttendanceService.createAttendance(attendanceData);
      return { success: true, data };
    } catch (error) {
      console.error('Create attendance error:', error);
      return { success: false, error: error.message };
    }
  }

  async getStats(params = {}) {
    try {
      const data = await AttendanceService.getAttendanceStats(params);
      return { success: true, data };
    } catch (error) {
      console.error('Get stats error:', error);
      return { success: false, error: error.message };
    }
  }

  async validateAndGenerateCredentials(eventId, eventDetails, userEmail) {
    try {
      const result = await AttendanceService.validateAndGenerateCredentials(eventId, eventDetails, userEmail);
      return { success: true, data: result };
    } catch (error) {
      console.error('Validate and generate credentials error:', error);
      return { success: false, error: error.message };
    }
  }

  async generateLink(eventId, eventDetails, methods) {
    try {
      const linkData = await AttendanceService.generateAttendanceLink(eventId, eventDetails, methods);
      return { success: true, data: linkData };
    } catch (error) {
      console.error('Generate link error:', error);
      return { success: false, error: error.message };
    }
  }

  async generateQR(eventId, eventDetails, methods) {
    try {
      const qrData = await AttendanceService.generateAttendanceQR(eventId, eventDetails, methods);
      return { success: true, data: qrData };
    } catch (error) {
      console.error('Generate QR error:', error);
      return { success: false, error: error.message };
    }
  }
}

export default new AttendanceController();